<template>
  <page :setup="getStatisticalAnalysis">
    <container-layout
      :menu="menu"
      :showAside="false"
      :defaultMenu="defaultMenu"
      @selectMainMenu="selectMenu"
      router
      class="dot-table"
    >
      <template v-slot:main>
        <div class="task-analysis-wrapper">
          <div class="task-analysis-top">
            <p class="title"></p>
            <div class="search">
              <p>人员检索：</p>
              <el-input
                v-model="keyWord"
                placeholder="关键字"
                @change="getStatisticalAnalysis"
              ></el-input>
              <el-button type="primary" @click="getStatisticalAnalysis"
                >查询</el-button
              >
            </div>
          </div>

          <template>
            <el-table
              :data="data"
              :height="tableHeight"
              :style="{ backgroundColor: '#3b3a39' }"
            >
              <el-table-column
                v-for="col in columns"
                :key="col.prop"
                :prop="col.prop"
                :type="col.type"
                :width="col.width"
                :label="col.label"
              ></el-table-column>
            </el-table>
          </template>
        </div>
      </template>
    </container-layout>
  </page>
</template>
<script>
import { getMenu } from './util';

export default {
  data() {
    return {
      keyWord: '',
      defaultMenu: '/task/analysis',
      data: [],
      columns: [
        {
          prop: 'name',
          label: '人员'
        },
        {
          prop: 'createUser',
          label: '创建项目'
        },
        {
          prop: 'uploadUser',
          label: '撰写'
        },
        {
          prop: 'reviewUser',
          label: '检阅'
        },
        {
          prop: 'checkUser',
          label: '验查'
        },
        {
          prop: 'signUser',
          label: '会签'
        },
        {
          prop: 'approveUser',
          label: '核定'
        }
      ]
    };
  },
  computed: {
    tableHeight() {
      return window.innerHeight - 200;
    },
    menu() {
      return getMenu(code => this.$hasPermission(code));
    }
  },
  methods: {
    selectMenu() {},
    async getStatisticalAnalysis() {
      const { data } = await this.$fetch.get(
        '/cowork/project/getStatisticalAnalysis',
        {
          module: 'work',
          params: { search: this.keyWord }
        }
      );
      //console.log(data, 'this.data//table');
      this.data = data.statisticalAnalysisList;
      return {
        data: data.statisticalAnalysisList,
        total: data.total
      };
    }
  }
};
</script>
<style lang="less" scoped>
.task-analysis-wrapper {
  padding: 0px 28px;
  .task-analysis-top {
    display: flex;
    justify-content: space-between;
    .title {
      color: #ffffff;
    }

    .search {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;

      p {
        width: 130px;
      }
    }
  }

  /deep/.el-table::before {
    height: 0px;
  }
}
/deep/.container-layout .container-layout-content > .el-main {
  border: none !important;
}
/deep/.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #3271a1;
  border-color: #3271a1;
}
</style>
